import styled from 'styled-components';
import { Text } from 'components/Typography';
import { getThemeColor } from 'utils/styled';
import TooltipPopover from '../TooltipPopover';

export const Popover = styled(Text).attrs({
  forwardedAs: TooltipPopover,
  variant: 'tooltip',
})`
  background-color: ${getThemeColor('s1')};
  border-radius: 8px;
  color: ${getThemeColor('white')};
  padding: 10px 11px;
`;

export const Arrow = styled.div`
  &,
  &::before {
    position: absolute;
    height: 8px;
    width: 8px;
    background: inherit;
  }

  visibility: hidden;

  &::before {
    visibility: visible;
    content: '';
    transform: rotate(45deg);
  }

  ${Popover}[data-popper-placement^='top'] > & {
    bottom: -4px;
  }

  ${Popover}[data-popper-placement^='bottom'] > & {
    top: -4px;
  }

  ${Popover}[data-popper-placement^='left'] > & {
    right: -4px;
  }

  ${Popover}[data-popper-placement^='right'] > & {
    left: -4px;
  }
`;
